'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFloppyDiskThreeDots, iconFloppyDiskThreeDotsTag } from '@ni/nimble-components/dist/esm/icons/floppy-disk-three-dots';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFloppyDiskThreeDots };
export { iconFloppyDiskThreeDotsTag };
export const NimbleIconFloppyDiskThreeDots = wrap(IconFloppyDiskThreeDots);